export const SORT_MANUAL = 'SORT_METHOD_MANUAL';
export const SORT_ALFABETIC = 'SORT_METHOD_ALFABETIC';
export const SORT_DATE = 'SORT_METHOD_DATE';
